<template>
  <div class="index-wrapper add-fixed index-wrapper-dialog">
    <div class="quit-wrapper">
      <el-button
        size="mini"
        @click="onSkipPageFn('/trainingInterview/login')"
      >退出</el-button>
    </div>
    <div class="screen-wrapper">
      <img class="bg" src="@/assets/image/bg.jpg" />
      <dv-loading class="loading">
        <img class="bg" src="@/assets/image/bg.jpg" />
        <div class="loading-text">欢迎来到AI模拟面试</div>
        <div class="start-btn">
          <img
            class="bg"
            src="@/assets/image/start-btn7.png"
            @click="onSkipBeBeingInterviewFn('/interview/be_being_interview', 2)"
          />
          <img
            class="bg"
            src="@/assets/image/start-btn5.png"
            @click="onSkipPageFn('/trainingInterview/report_list')"
          />
        </div>
      </dv-loading>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  data() {
    return {
      channel: '' // 机器ID-渠道ID
    }
  },
  created() {
    this.channel = localStorage.getItem('channel')
    if (this.$route.query.channel) {
      this.channel = this.$route.query.channel
      localStorage.setItem('channel', this.channel)
      this.setChannel(this.channel)
    } else if (this.channel) {
      this.setChannel(this.channel)
    } else {
      this.$message({
        message: '参数错误',
        type: 'error'
      })
      return false
    }
  },
  methods: {
    ...mapMutations({
      setChannel: 'SET_CHANNEL'
    }),
    // 跳转页面
    onSkipBeBeingInterviewFn(path, id = null) {
      this.$router.push({
        query: {
          id
        },
        path
      })
    },
    // 跳转页面
    onSkipPageFn(path) {
      this.$router.push({
        path
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.index-wrapper, position fixed
  left 0
  top 0
  width 100%
  height 100%
  z-index 99
  &.add-fixed
    position fixed
  .screen-wrapper
    position relative
    width 100%
    height 100%
    padding 36px 50px 30px
    box-sizing border-box
  .quit-wrapper
    position absolute
    left 30px
    top 20px
    width 100%
    height auto
    z-index 1000
    button
      border-color #02F7F2
      color #02F7F2
      background-color transparent
.bg
  position absolute
  left 0
  top 0
  bottom 0
  z-index -1
  width 100%
  height 100%
.loading
  position fixed
  left 0
  top 0
  width 100%
  height 100%
  display flex
  align-items center
  justify-content center
  z-index 999
  background-color #000
  .loading-text
    font-weight bold
    line-height 100px
    font-size 30px
    text-align center
    opacity 0.8
    color #fff
  .start-btn
    width 100%
    height auto
    display flex
    img
      position relative
      width 200px
      height auto
      display block
      cursor pointer
      margin 0 30px
      z-index 10
</style>
